const scrollToError = (errors) => {

  if(!errors || Object.keys(errors).length < 1) return

  const firstErrorKey = Object.keys(errors)[0]
  const firstError = errors[firstErrorKey]
  if(firstErrorKey === 'serverError') return

  let query = firstErrorKey
  let sectionFilter = ''
  if(firstError instanceof Object){
    if(firstError instanceof Array){
      const firstNotEmpty = Object.keys(firstError).find(e => !!firstError[e])
      query = Object.keys(firstError[firstNotEmpty])[0]
      sectionFilter = `div.anchor-${firstErrorKey}-${firstNotEmpty} `
    }else{
      query = Object.keys(firstError)[0]
      sectionFilter = `div.anchor-${firstErrorKey} `
    }
  }
  const errorField = document.querySelector(`${sectionFilter}input[name="${query}"], ${sectionFilter}div[name="${query}"] input`)
  errorField && errorField.focus()
}

export default scrollToError;


// WEBPACK FOOTER //
// ./src/utils/scrollToError.js